module.exports = __webpack_public_path__ + "img/adobe-illustrator-cc.b30a1640.svg";